<template>
  <dashboard-section :bordered="$device.isMobileOrTablet" class="p-t-3:t p-t-4:d">
    <router-link
        v-if="$device.isMobile"
        slot="header"
        :to="{
          name: 'dashboard::pro::jobs',
          params: {
            jobsStatusAlias,
          },
          query: $route.query,
        }"
        class="BACK">
      <vk-icon name="arrow-left" class="ICON" />Back to jobs
    </router-link>
    <div class="d-flex flex-1-1 flex-0-1:d flex-1-1:w fd-column fd-row:w">
      <div class="d-flex flex-1-1 fd-column">
        <div class="d-flex fd-column ai-center ai-start text-center text-left:d m-b-1">
          <h5 class="FULL-NAME" selenium="job-details-full-name">
            {{ job.location.first_name | fullName(job.location.last_name) }}
          </h5>
          <span v-if="isFetching" class="x-pulse PLACEHOLDER-REDUCED" />
          <time-received-with-status v-else />
        </div>
        <div class="d-flex jc-center jc-start m-b-1">
          <span v-if="isFetching" class="x-pulse PLACEHOLDER" />
          <template v-else>
            <span class="text-md DARK-TEXT p-r-1:mo">Job status</span>
            <status-bubble
                v-if="match.status"
                :status="match.status"
                class="STATUS-BUBBLE"
                selenium="job-details-status" />
          </template>
        </div>
        <div v-if="isPotentialMatch || (isPastStatusAlias && subStatus)" class="d-flex jc-start m-b-2:d">
          <span v-if="isFetching" class="x-pulse PLACEHOLDER" />
          <template v-else>
            <span class="text-md DARK-TEXT p-r-1:mo">Contact status</span>
            <sub-status-bubble
                :status="subStatus"
                class="STATUS-BUBBLE"
                selenium="job-details-status" />
          </template>
        </div>
        <primary-cta
            v-if="$device.isNeitherMobileOrTablet"
            class="d-flex"
            @update="fetch" />
      </div>
      <div
          v-if="$device.isNeitherMobileOrTablet && !isFinishedMatch
          || $device.isNeitherMobileOrTablet && isClosedMatch"
          class="d-flex flex-1-1 fd-column ai-end:w m-l-1:w">
        <secondary-cta @update="fetch"/>
      </div>
    </div>
    <primary-cta
        v-if="$device.isMobileOrTablet && !isNewMatch"
        slot="footer"
        class="d-flex"
        @update="fetch"/>
  </dashboard-section>
</template>

<script>
import jobParams from '@/mixins/job-params';
import job from '@/mixins/job';
import DashboardSection from '@/views/Dashboard/components/DashboardSection';
import StatusBubble from '@/views/Dashboard/components/StatusBubble';
import SubStatusBubble from '@/views/Dashboard/components/SubStatusBubble';

import TimeReceivedWithStatus from './TimeReceivedWithStatus';
import PrimaryCta from './PrimaryCta';
import SecondaryCta from './SecondaryCta';

export default {
  name: 'top-bar',
  components: {
    DashboardSection,
    TimeReceivedWithStatus,
    StatusBubble,
    SubStatusBubble,
    PrimaryCta,
    SecondaryCta,
  },
  mixins: [
    jobParams,
    job,
  ],
  computed: {
    isFetching () {
      return this.currentJobMeta.status === this.$options.REQUEST_LIFECYCLE.FETCHING;
    },
    subStatus () {
      return this.match.sub_status;
    },
  },
  methods: {

    async fetch () {
      if (this.job && this.job.order_hash) {
        const jobId = this.job.order_hash;

        await this.transitionJob({
          action: this.$options.MATCH_STATUS_ACTIONS.SEE,
          order_hash: jobId,
        });

        await this.fetchWorkOrderMatches({
          params: {
            order_hash: jobId,
            size: 1,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";

  .FULL-NAME {
    @include h5;
    @include margin(0 0 1 0, $md: 0 1 1 0);
  }

  .STATUS-BUBBLE {
    @include margin-left(0, $md: 0.5);
  }

  .PLACEHOLDER {
    @include rect(80px, 24px);
    @include responsive(border-radius, 2*$unit, $md: 0);

    @include desktop {
      @include rect(150px, 24px);
    }
  }

  .PLACEHOLDER-REDUCED {
    @include rect(120px, 17px);
    margin: $unit/4 0;
  }

  .BACK {
    @include link-black;
    display: flex;
    align-items: center;
  }

  .ICON {
    @include h4;
    margin-right: $unit;
  }
  .DARK-TEXT {
    color: #808286;
  }
</style>
